import axios from "axios";
import { apiUrl } from "../../App";

export async function deleteUserExclusionFromCommunityRankingsUseCase(
  communityId: string,
  userId: string
) {
  return await axios.delete(`${apiUrl}/admin/rankings/excluded-user`, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
    },
    data: { communityId, userId },
  });
}
